var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { addIconSVG } from "../../../technical-fundamental/Icon/Icon/Icon.utils";
var Input = forwardRef(function (_a, ref) {
    var id = _a.id, name = _a.name, icon = _a.icon, iconSvg = _a.iconSvg, className = _a.className, uppercase = _a.uppercase, onChange = _a.onChange, maskFonction = _a.maskFonction, maxWidth = _a.maxWidth, style = _a.style, otherProps = __rest(_a, ["id", "name", "icon", "iconSvg", "className", "uppercase", "onChange", "maskFonction", "maxWidth", "style"]);
    var onChangeSurcharge = function (event) {
        var value = event.target.value;
        var selectionStart = event.target.selectionStart;
        if (!selectionStart) {
            selectionStart = 0;
        }
        if (uppercase) {
            event.target.value = "".concat(value).toUpperCase();
        }
        if (maskFonction) {
            var valueMasked = maskFonction(value);
            selectionStart = selectionStart + valueMasked.length - value.length;
            event.target.value = valueMasked;
        }
        if (!otherProps.type || ["text"].includes(otherProps.type)) {
            event.target.setSelectionRange(selectionStart, selectionStart);
        }
        if (onChange) {
            onChange(event);
        }
    };
    var styleGroup = __assign(__assign({}, style), { width: "100%", maxWidth: maxWidth || undefined });
    if (icon || iconSvg) {
        var _b = addIconSVG(iconSvg, "fr-input-wrap", {}), inputClassName = _b.className, inputStyle = _b.style;
        return (React.createElement("div", { className: icon ? "fr-input-wrap ".concat(icon) : inputClassName, style: inputStyle },
            React.createElement("input", __assign({}, otherProps, { className: "fr-input ".concat(className || ""), id: id, name: name, ref: ref, onChange: onChangeSurcharge, style: styleGroup }))));
    }
    return (React.createElement("input", __assign({}, otherProps, { className: "fr-input ".concat(className || ""), id: id, name: name, ref: ref, onChange: onChangeSurcharge, style: styleGroup })));
});
export default Input;
